import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

import { CIMD_MCP_AGENT_JOB_TITLE, DCR3P_AGENT_JOB_TITLE } from './agentJobTitles';

export type ProfileCardKind = 'person' | 'studio-agent' | 'external-agent';

export function getProfileCardKind({
	userType,
	appType,
	jobTitle,
}: {
	userType?: string | null;
	appType?: string | null;
	jobTitle?: string | null;
}): ProfileCardKind {
	// The MCP job title identifies the card route; invoking-user attribution is optional.
	if (
		userType === 'AppUser' &&
		(jobTitle === DCR3P_AGENT_JOB_TITLE || jobTitle === CIMD_MCP_AGENT_JOB_TITLE) &&
		isExperimentEnabled('cc_external_agent_profile_card')
	) {
		return 'external-agent';
	}

	return typeof appType === 'string' && appType.toLowerCase() === 'agent'
		? 'studio-agent'
		: 'person';
}
